import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  nav: {
    padding: [theme.spacing(4), 0, 12],
    borderBottom: [1, 'solid', theme.palette.colors.lightGraySecondary],
    [theme.breakpoints.up('mobile')]: {
      display: 'flex',
      flexDirection: 'row',
      padding: 0,
      borderBottom: 'none',
    },
  },
  navButton: {
    minWidth: 148,
    height: 34,
    padding: [0, 20],
    '&:hover': {
      color: theme.palette.colors.white,
    },
    '&:focus': {
      color: theme.palette.colors.white,
      outline: 'none',
      textDecoration: 'none',
    },
  },
  navItem: {
    padding: [12, 0],
    width: 'auto',
    [theme.breakpoints.up('mobile')]: {
      padding: 0,
      marginRight: theme.spacing(4),
      '&:last-child': {
        marginRight: 0,
      },
    },
  },
  navLink: {
    color: theme.palette.colors.darkBlue,
    fontSize: theme.spacing(2),
    [theme.breakpoints.up('mobile')]: {
      color: theme.palette.colors.black,
      fontWeight: '700',
      '&:focus': {
        textDecoration: 'none',
        color: theme.palette.colors.black,
      },
    },
    '&:hover': {
      color: theme.palette.colors.darkBlue,
    },
    '&::after': {
      content: "''",
      display: 'block',
      width: 0,
      height: 4,
      marginTop: 8,
      background: theme.palette.colors.red,
      transition: 'width .3s',
    },
    '&:hover::after': {
      width: '100%',
    },
  },
  topItem: {
    width: '100%',
    height: 34,
    fontSize: theme.spacing(2),
    display: 'flex',
    marginBottom: 12,
    padding: 0,
  },
  topItemLink: {
    display: 'flex',
    height: '100%',
    width: '100%',
    color: theme.palette.colors.white,
    backgroundColor: theme.palette.colors.teal,
    borderRadius: 4,
    fontWeight: '700',
    padding: [0, 7],
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      color: theme.palette.colors.white,
    },
    '&:focus': {
      color: theme.palette.colors.white,
      textDecoration: 'none',
    },
  },
  topItemLinkSecondary: {
    border: [1, 'solid', theme.palette.colors.teal],
    backgroundColor: theme.palette.colors.white,
    color: theme.palette.colors.teal,
    '&:hover': {
      color: theme.palette.colors.teal,
    },
    '&:focus': {
      color: theme.palette.colors.teal,
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/NonAuthHomePage/components/Header/useStyles.js